import React, { useState } from 'react'
import LoanUtilityMain from './newloanutility'
import ProcessingFee from './ProcessingFee'
import ProductMain from './ProductMain'
import Product from './ProductMainnew'
import OverdueUtility from './Overdue/OverdueUtility'
import { Company_DATA, CheckFunction, ABHICASH_LIKE, CHECK_COMPANY_TENANT } from '../../../../../layouts/MainTenantconfig'
export default function configMain({ admin }) {
    const tenant = CheckFunction();
    const [tabs, setabs] = useState('loan')
    const handletabs = (type) => {
        setabs(type)
    }
    return (
        <>
            <div className="LoanUtility">

                <div className="tabs">
                    <div className={`tab ${tabs === 'loan' ? 'active' : ''}`} onClick={() => handletabs('loan')}>
                        <h5>Loan Utility</h5>
                    </div>
                    <div className={`tab ${tabs === 'processing' ? 'active' : ''}`} onClick={() => handletabs('processing')}>
                        <h5>Processing Fee</h5>
                    </div>
                    <div className={`tab ${tabs === 'product' ? 'active' : ''}`} onClick={() => handletabs('product')}>
                        <h5>Product</h5>
                    </div>
                    
                             <div className={`tab ${tabs === 'overdue' ? 'active' : ''}`} onClick={() => handletabs('overdue')}>
                        <h5>Overdue</h5>
                    </div>
                </div>

                {
                    tabs === 'loan' ?
                        <LoanUtilityMain />
                        : ''}
                {
                    tabs === 'processing' ?
                        <ProcessingFee />
                        : ''}
                {
                    tabs === 'product' ?
                        // <ProductMain />
                        <Product />
                        : ''}
                
                {
                    tabs === 'overdue' ?
                        <OverdueUtility admin={admin} />
                        : ''}
            </div>
        </>
    )
}
